import { useEffect, useState } from "react";

import { cloneDeep } from "lodash";

import MomSysShipActionButtonLayout from '../layout/MomSysShipActionButtonLayout';
import MomSysShipActionDialog from '../dialogTypes/MomSysShipActionDialog';

function MomSysShipActionButton (props) {

    const {id, schema, refresh, onUpdateMaster, onShipSelectMst, onSuccess, customizeErrorMsgCallback, ...others } = props;
    
    const [ open, setOpen ] = useState(false);

    const [modifiedSchema, setModifiedSchema] = useState();

    useEffect(() => {

        if(schema) {

            let modifiedSchema = cloneDeep(schema);

            let shipIdColumn = {};
            shipIdColumn.name = "shipId";

            shipIdColumn.formGroup = 0;
            shipIdColumn.formOrder = 1;

            shipIdColumn.type = "text";

            shipIdColumn.readonly = true;
            shipIdColumn.disabled = true;
            
            modifiedSchema.columns.push (shipIdColumn);

            let orderBuyerIdColumn = {};
            orderBuyerIdColumn.name = "orderBuyerId";

            orderBuyerIdColumn.formGroup = 0;
            orderBuyerIdColumn.formOrder = 2;

            orderBuyerIdColumn.type = "text";

            orderBuyerIdColumn.readonly = true;
            orderBuyerIdColumn.disabled = true;

            modifiedSchema.columns.push (orderBuyerIdColumn);

            let materialNameColumn = {};
            materialNameColumn.name = "materialName";

            materialNameColumn.formGroup = 0;
            materialNameColumn.formOrder = 3;

            materialNameColumn.type = "text";

            materialNameColumn.readonly = true;
            materialNameColumn.disabled = true;
            
            modifiedSchema.columns.push (materialNameColumn);

            let materialCodeColumn = {};
            materialCodeColumn.name = "materialCode";

            materialCodeColumn.formGroup = 0;
            materialCodeColumn.formOrder = 4;

            materialCodeColumn.type = "text";

            materialCodeColumn.readonly = true;
            materialCodeColumn.disabled = true;
            
            modifiedSchema.columns.push (materialCodeColumn);

            let materialCodeVerColumn = {};
            materialCodeVerColumn.name = "materialCodeVer";

            materialCodeVerColumn.formGroup = 0;
            materialCodeVerColumn.formOrder = 5;

            materialCodeVerColumn.type = "text";

            materialCodeVerColumn.readonly = true;
            materialCodeVerColumn.disabled = true;
            
            modifiedSchema.columns.push (materialCodeVerColumn);

            let shipmentQtyColumn = {};
            shipmentQtyColumn.name = "shipmentQty";

            shipmentQtyColumn.formGroup = 0;
            shipmentQtyColumn.formOrder = 6;

            shipmentQtyColumn.type = "text";

            shipmentQtyColumn.readonly = true;
            shipmentQtyColumn.disabled = true;
            
            modifiedSchema.columns.push (shipmentQtyColumn);

            let dueDateColumn = {};
            dueDateColumn.name = "dueDate";

            dueDateColumn.formGroup = 0;
            dueDateColumn.formOrder = 7;

            dueDateColumn.type = "text";

            dueDateColumn.readonly = true;
            dueDateColumn.disabled = true;
            
            modifiedSchema.columns.push (dueDateColumn);
            
            let lotNoColumn = {};
            lotNoColumn.name = "lotNo";

            lotNoColumn.required = true;
            lotNoColumn.formGroup = 1;
            lotNoColumn.formOrder = 1;

            lotNoColumn.type = "text";

            lotNoColumn.readonly = true;
            lotNoColumn.disabled = true;
            
            modifiedSchema.columns.push (lotNoColumn);

            setModifiedSchema(modifiedSchema);
        }

    },[schema])

    const onOpen = () => {

        setOpen ( true );

    };

    const onClose = () => {

        setOpen ( false );

    };

    const onShipSuccess = (msg) => {

        if (onSuccess) {
    
            onSuccess(msg);
      
        }

        if(onUpdateMaster) {

            onUpdateMaster();

        }

        refresh.refresh();

      };

    return (
        <>
        <MomSysShipActionButtonLayout id = {id+"-ship-action-button"} onClick = {onOpen} {...others}/>
        <MomSysShipActionDialog
            id = {id + "shipAction-dialog"}
            schema = {modifiedSchema}
            onShipSelectMst = {onShipSelectMst}
            open={open}
            onClose={onClose}
            onSuccess={onShipSuccess}
        />
        </>
    )

}

export default MomSysShipActionButton;